import React, { Component } from 'react';
import { Modal, Button, Form, message, Row, Col, Icon, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const FormItem  = Form.Item;

class CreateForm extends Component {
    componentDidMount() {
        const { form: { getFieldDecorator } } = this.props;
        getFieldDecorator('userOptions', { initialValue: [] });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { form: { setFieldsValue } } = this.props;
        setFieldsValue({
            [idName]: id,
            [optionsName]: options,
        });
    }

    handleAdd = () => {
        this.props.submit();
    }

    render() {
        const { hospitalDepartmentId, form: { getFieldDecorator } } = this.props;
        const formItemLayout = {
            labelCol: {
                sm: { span: 7 },
                md: { span: 7 },
            },
            wrapperCol: {
                sm: { span: 16, offset: 1 },
                md: { span: 16, offset: 1 },
            },
        };
        const require = <span style={{color:'#F00'}}>*</span>;
        return (
            <Form>
                <FormItem {...formItemLayout} label={<span>{require}选择CRC</span>}>
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('userId')(
                                    <HighSearchInput
                                        name="user"
                                        keyword='nameCode'
                                        style={{ width: 200 }}
                                        params={{ limit: 20, hospitalDepartmentId }}
                                        placeholder="输入姓名/工号检索"
                                        url={API_URL.hospital.queryPositionCrcList}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'userId', 'userOptions')}
                                    />
                                )
                            }
                        </Col>
                        <Col span={6}>
                            <Button type="primary" onClick={this.handleAdd}>添加</Button>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}

class SetPCRC extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { hospitalDepartmentId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryByHospitalDepartmentId,
            data: { hospitalDepartmentId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.list,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        this.formRef.validateFieldsAndScroll((errors, values) => {
            const {
                userId,
                userOptions = [],
            } = values;
            if (!userId) {
                message.warning('请选择CRC');
                return;
            } else {
                const isExist = userOptions.some(item => item.value == userId);
                if (!isExist) {
                    message.warning('请选择正确的CRC');
                    return;
                }
            }

            const { record: { hospitalDepartmentId } } = this.state;
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.hospital.addHospitalMainCrc,
                data: {
                    userId,
                    hospitalDepartmentId,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.setState({ loading: true }, () => {
                        this.loadData();
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            }
            $.sendRequest(options);
        });
    }

    handleDelete = (hospitalMainCrcId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.delHospitalMainCrc,
            data: { hospitalMainCrcId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                    this.props.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { data = [] } = this.state;
        let result = null;
        if (data.length > 0) {
            result = data.map((item) => 
                <div
                    className="item-btn"
                    key={item.hospitalMainCrcId}
                    style={{ width: '100%', padding: 0, border: 'none', background: '#fff', marginTop: '10px' }}
                >
                    <div
                        style={{
                            maxWidth: 258,
                            display: 'inline-block',
                            padding: '0 6px',
                            background: '#eee',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            verticalAlign: 'top',
                        }}
                    >{item.userCompellation}【{item.employeeCode}】</div>
                    <Icon
                        type="close"
                        onClick={() => this.handleDelete(item.hospitalMainCrcId)}
                        style={{ marginLeft: 10, color: '#F00', fontSize: '16px', cursor: 'pointer' }}
                    />
                </div>   
            )
        }
        return result;
    }

    render() {
        const { loading, visible, record: { hospitalDepartmentId } } = this.state;
        const mapPropsToFields = () => ({});
        CreateForm = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title='配置PCRC'
                visible={visible}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                width="500px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ margin: '10px 0' }}>
                        <CreateForm
                            submit={this.submit}
                            ref={el => this.formRef = el}
                            hospitalDepartmentId={hospitalDepartmentId}
                        />
                    </div>
                    <div
                        className="modal-content"
                        style={{ padding: '10px 0 0 157px', borderTop: '1px solid #d1d1d1' }}
                    >
                        <ul className="modal-list" style={{position: 'relative'}}>
                            <li className="modal-item">
                                {/* <div className="item-left" style={{width: 126, paddingRight: 10}}></div>
                                <div className="item-right">
                                    { this.getDataList() }
                                </div> */}
                            </li>
                        </ul>
                    </div>
                    <div style={{marginLeft: '40px'}}>
                        { this.getDataList() }
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default SetPCRC;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/SetPCRC.js